import O2oEnrollAudit from './src/main';

/* istanbul ignore next */
O2oEnrollAudit.install = function(Vue) {
  Vue.component(O2oEnrollAudit.name, O2oEnrollAudit);
};

export default O2oEnrollAudit;
